module.exports = __webpack_public_path__ + "img/avatar.b5362841.svg";